import Link from 'next/link';

interface TagPillProps {
  label: string;
  href?: string;
  active?: boolean;
  onClick?: () => void;
}

export default function TagPill({ label, href, active, onClick }: TagPillProps) {
  const className = `inline-block border border-[#D4D4D4] px-3 py-1.5 text-[12px] font-['IBM_Plex_Sans',system-ui,sans-serif] transition-all duration-150 cursor-pointer ${
    active
      ? 'bg-[#1A1A1A] text-white border-[#1A1A1A]'
      : 'text-[#2D2D2D] hover:bg-[#1A1A1A] hover:text-white hover:border-[#1A1A1A]'
  }`;

  if (href) {
    return (
      <Link href={href} className={className}>
        {label}
      </Link>
    );
  }

  return (
    <button onClick={onClick} className={className}>
      {label}
    </button>
  );
}
